import ReassignIBManagerForm from './ReassignIBManagerForm';

export default ReassignIBManagerForm;
